import { useStaticQuery, graphql } from 'gatsby'
import useEdgeDataFetcher from './useEdgeDataFetcher'

export default () => {
  const prefetchedStates = useStaticQuery(
    graphql`
      query {
        staticData {
          statesData {
            states {
              fullName
              displayName
            }
          }
        }
      }
    `
  ).staticData.statesData.states

  const [statesDataLoaded] = useEdgeDataFetcher((!prefetchedStates || prefetchedStates.length < 2) && `/plate2vin/states?a=b`, undefined, undefined, 'plate2vinstates')
  const standardizedStatesData = statesDataLoaded && statesDataLoaded.states && statesDataLoaded.states[0] && statesDataLoaded.states.map(state => ({ displayName: state.abbreviation, fullName: state.name }))

  const states = standardizedStatesData || prefetchedStates

  return states
}
